<template>
  <VpVueForm
    :fields="fields"
    :id="id"
    class="vp-p-4"
    :save="save"
    :get="get"
    :del="del"
    width="500px"
    cache="whatsappCloudApiBroadcast"
    :collection-cache="'whatsappCloudApiBroadcasts'"
    feature="WHATSAPP_BROADCAST"
    ref="broadcastForm"
  >
    <template #default="{ state, response, isCreating }">
      <VpField rules="required" name="Broadcast Name" label="Broadcast Name">
        <VpInput>
          <VpTextBox v-model="state.name" />
        </VpInput>
      </VpField>

      <VpField label="Select Contacts" note="">
        <div
          class="vp-border-gray-200 vp-border vp-rounded-md vp-overflow-hidden"
        >
          <VpLoaderContainer overlay :loading="loading">
            <div class="vp-p-5 vp-space-y-4">
              <VpField
                label="Tags"
                :note="
                  isCreating
                    ? `Contact having any of the tags you select will be added to broadcast.`
                    : ``
                "
              >
                <TagsInput
                  v-if="isCreating"
                  type="contact"
                  v-model="state.tagIds"
                  @input="getTotalContactCount(state)"
                />

                <TagsDisplay
                  v-else-if="response.tags.length"
                  :value="response.tags"
                />

                <p v-else class="vp-text-xs vp-text-gray-500">
                  No tags are selected.
                </p>
              </VpField>
              <VpField
                label="Funnels"
                :note="
                  isCreating
                    ? `Contact having any of the funnel you select will be added to broadcast.`
                    : ``
                "
              >
                <FunnelMultiInput
                  v-if="isCreating"
                  v-model="state.funnelIds"
                  @input="getTotalContactCount(state)"
                />
                <div
                  class="vp-flex vp-flex-wrap vp-gap-1"
                  v-else-if="response.funnels.length"
                >
                  <FunnelDisplay
                    v-for="item in response.funnels"
                    :key="item.id"
                    :value="item"
                  />
                </div>
                <p v-else class="vp-text-xs vp-text-gray-500">
                  No funnel is selected.
                </p>
              </VpField>
              <div>
                <p class="vp-text-primary-500">
                  Selected Contacts:
                  {{
                    isCreating ? totalContacts : response?.summary.recipients
                  }}
                </p>
              </div>
            </div>
          </VpLoaderContainer>
        </div>
      </VpField>

      <VpField>
        <template #default>
          <VpField
            rules="required"
            name="Template"
            label="Whatsapp Template"
            note='The templates you added in the "Templates" section will only be available here.'
          >
            <VpInput>
              <VpSelect
                v-model="state.templateId"
                :options="whatsappTemplates"
              />
            </VpInput>
          </VpField>
        </template>
      </VpField>
    </template>
  </VpVueForm>
</template>

<script>
import { OpenInNew } from "icons/icons.js";
import TagsDisplay from "components/src/tags/display.vue";
import TagsInput from "components/src/tags/input.vue";
import FunnelDisplay from "components/src/funnel/display.vue";
import FunnelMultiInput from "components/src/funnel/multi-input.vue";

import getApi from "./get.gql";
import upsertApi from "./upsert.gql";
import getContacts from "../contacts-count.gql";
import move from "../move.gql";
import whatsappTemplates from "./templates.gql";

export default {
  icons: {
    OpenInNew,
  },
  props: {
    id: [Number, String],
  },

  components: {
    FunnelDisplay,
    TagsDisplay,
    TagsInput,
    FunnelMultiInput,
  },

  data() {
    return {
      totalContacts: 0,
      loading: false,
      isSaving: false,
      whatsappTemplates: [],
      fields: [
        "name",
        "templateId",
        { name: "tagIds", value: [] },
        { name: "funnelIds", value: [] },
      ],
    };
  },

  mounted() {
    if (this.id == "+") {
      this.getTotalContactCount(null);
    }
    this.getWhatsappTemplates();
  },

  methods: {
    getTotalContactCount(state) {
      this.loading = true;
      this.$query(getContacts, {
        filters: {
          tagIds: state?.tagIds.length ? state?.tagIds : null,
          funnelIds: state?.funnelIds.length ? state?.funnelIds : null,
        },
      })
        .then(({ data: { contacts } }) => {
          this.totalContacts = contacts.pagination.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getWhatsappTemplates() {
      this.$query(whatsappTemplates, {
        page: 1,
        perPage: -1,
      })
        .then(({ data }) => {
          this.whatsappTemplates =
            data.whatsappCloudApiBroadcastTemplates.data.map((t) => ({
              label: t.name,
              value: t.id,
            }));
        })
        .catch(() => {});
    },

    get(id) {
      return this.$query(getApi, {
        id,
      }).then(({ data }) => {
        const broadcast = data.whatsappCloudApiBroadcast;

        this.$emit("item", broadcast);

        return {
          values: {
            ...broadcast,
            funnelIds: broadcast.funnels?.map((item) => item.id),
            tagIds: broadcast.tags?.map((item) => item.id),
            templateId: broadcast.templateV2.id,
          },
          res: data,
        };
      });
    },

    save(id, data) {
      return this.$mutate(upsertApi, {
        id,
        input: data,
      })
        .then(({ data }) => {
          this.$router.push({
            name: "whatsapp-cloud-api-broadcast",
            params: {
              id: data.upsertWhatsappCloudApiBroadcast.id,
            },
          });

          return data;
        })
        .catch(() => {});
    },

    del(id, action) {
      return this.$mutate(move, {
        id: parseInt(id),
        action,
      }).then(() => {
        this.$router.push({
          name: "whatsapp-cloud-api-broadcasts",
        });
      });
    },
  },
};
</script>
